import React, { useContext } from 'react';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { getContext } from 'common';
import Tabs, { TabsProps } from 'components/Tabs';
import { AppToolbarContext } from './';

export interface AppToolbarTabsProps extends React.ComponentPropsWithRef<'div'> {
  /** The icon for the button. Consider using `Tab` component. */
  children: React.ReactNode;
  /** Tabs properties. See `Tabs` component for details.  */
  tabsProps?: Partial<TabsProps>;
}

/** Formatted Tabs for use on the AppToolbar. */
const AppToolbarTabs = React.forwardRef<HTMLElement, AppToolbarTabsProps>((props: AppToolbarTabsProps, ref) => getContext(({ RTL }) => {
  const {
    tabsProps,
    children,
  } = props;
  const appToolbarContext: any = useContext(AppToolbarContext);
  const { style: tabsStyle, ...restOfTabsProps } = tabsProps;
  const TABS_STYLE_LARGE = {
    style: {
      margin: RTL ? `0 0 0 ${Tokens.SPACING.SPACING_8}` : `0 ${Tokens.SPACING.SPACING_8} 0 0`,
      ...tabsStyle,
    },
  };
  const TABS_STYLE_SMALL = {
    style: {
      margin: 0,
      ...tabsStyle,
    },
  };
  const TABS_STYLE = appToolbarContext.deviceType !== 'Mobile' ? TABS_STYLE_LARGE : TABS_STYLE_SMALL;
  return (
    <Tabs ref={ref} {...TABS_STYLE} {...restOfTabsProps} >
      {children}
    </Tabs>
  );
}));

AppToolbarTabs.displayName = 'AppToolbarTabs';

AppToolbarTabs.defaultProps = {
  tabsProps: {},
};

export default AppToolbarTabs;
